export default {
    BASE_URL: (process.env.NODE_ENV === 'development') ? "http://localhost:5000" : "https://tlstorevserver2.vulmiqi.com"
    // BASE_URL: "http://localhost:5000",

};
